import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {ResponsiveContainer, PieChart as PChart, Cell, Pie} from 'recharts';
import {BarLegend, ChartContainer, StyledPieChart, StyledTotal, StyledLegendDot} from './StyledPieChart';
import {colorHelpers} from '../../../utils/helpers';

const PieChart = ({
  barWidth = 40,
  chartHeight = 300,
  cornerRadius = 0,
  data,
  isAnimationActive = true,
  isEnableLegend = true,
  isEnableTotal = false,
  outerRadius = 110,
  pieProps,
  renderTotal,
  renderValue,
  totalTitle = 'Total',
  ...rest
}) => {
  const [chartData, setChartData] = useState([]);
  const [total, setTotal] = useState(0);

  useEffect(() => {
    if (data) {
      let total = data.map(d => d.value).reduce((acc, currentValue) => acc + currentValue, 0);
      if (renderTotal) total = renderTotal(total);
      setChartData(data.map(d => ({
        color: d?.color || colorHelpers.generateRandomColor(),
        name: d.name,
        value: d.value
      })));
      setTotal(total);
    }
  }, [data, renderTotal]);

  return (
    <StyledPieChart {...rest}>
      <ChartContainer>
        <ResponsiveContainer height={chartHeight} width='100%'>
          <PChart>
            <Pie
              {...pieProps}
              cornerRadius={cornerRadius}
              innerRadius={outerRadius - barWidth}
              outerRadius={outerRadius}
              data={chartData}
              dataKey='value'
            >
              {chartData.map((entry, index) =>
                <Cell fill={entry.color || 'transparent'} key={index} />)}
            </Pie>
          </PChart>
        </ResponsiveContainer>
        {isEnableTotal && (
          <StyledTotal>
            <label className='pie-chart-total-label'>{totalTitle}</label>
            <span className='pie-chart-total-value'>{total}</span>
          </StyledTotal>
        )}
      </ChartContainer>
      {isEnableLegend && (
        <BarLegend className='pie-chart-bar-legend'>
          {chartData.map((item, key) => {
            const {color, name, value} = item;
            return (
              <div className='d-flex align-center justify-space-between' key={key}>
                <span className='d-flex align-center'>
                  <StyledLegendDot color={color}/>
                  {name}
                </span>
                <b className='price'>{renderValue ? renderValue(value) : value}</b>
              </div>
            )
          })}
        </BarLegend>
      )}
    </StyledPieChart>
  );
}

PieChart.propTypes = {
  barWidth: PropTypes.number,
  chartHeight: PropTypes.number,
  cornerRadius: PropTypes.number,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      color: PropTypes.string,
      name: PropTypes.string.isRequired,
      value: PropTypes.number.isRequired
    })
  ),
  isAnimationActive: PropTypes.bool,
  isEnableTotal: PropTypes.bool,
  isEnableLegend: PropTypes.bool,
  outerRadius: PropTypes.number,
  pieProps: PropTypes.object,
  renderTotal: PropTypes.func,
  renderValue: PropTypes.func,
  totalTitle: PropTypes.string,
}

export default PieChart;
